import { render, staticRenderFns } from "./add-group.vue?vue&type=template&id=12c0bde8&scoped=true"
import script from "./add-group.vue?vue&type=script&lang=js"
export * from "./add-group.vue?vue&type=script&lang=js"
import style0 from "./add-group.vue?vue&type=style&index=0&id=12c0bde8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0bde8",
  null
  
)

export default component.exports